(function () {
    'use strict';

    angular.module('swif.publicLightning')
    .config(route)
    .controller('TaskRecurrentDeleteController', TaskRecurrentDeleteController);

    function resolveData(openstc) {
        'ngInject';
        return openstc.task.resolveData();
    }

    route.$inject = ['$routeProvider', 'swifPublicLightningConstant'];
    function route ($routeProvider, constant) {
        'ngInject';
        $routeProvider.when(constant.task.routes.table_view, {
            templateUrl: 'partials/openstc/tasks_table_view.html',
            controller: TasksController,
            reloadOnSearch: false,
            resolve: {
                data: ['swifPublicLightningService', function (service) {
                    return service.tasks.resolveData(undefined, 'publicLightning');
                }]
            }
        });
        $routeProvider.when(constant.task.routes.explorer_view, {
            templateUrl: 'partials/openstc/tasks_explorer_view.html',
            controller: TasksController,
            reloadOnSearch: false,
            resolve: {
                data: ['swifPublicLightningService', function (service) {
                    return service.tasks.resolveData(undefined, 'publicLightning');
                }]
            }
        });
    }


    function TasksController ($scope, $location, swif, openstc, data, swifAchatsService) {
        'ngInject';
        console.log('init TasksController');
        $scope.modules = swif.module.modules;
        $scope.data = data;
        $scope.countFilter = openstc.task.getCountFilter();
        $scope.cart = swif.cart;

        $scope.achat = swifAchatsService;

        $scope.tasks = data.tasks;
        $scope.attachmentsAction = swif.action.getActionById('intervention', 'meta', 'attachments');

        $scope.preModalTask = function (data) {
            openstc.task.preModal(data);
            if (data.action.id === 'add') {
                if (
                    $location.path() === openstc.task.routes.explorer_view ||
                    $location.path() === openstc.task.routes.table_view
                ) {
                    data.model.state = 'done';
                }
            }
        };

        $scope.preValidateTask = function (data) {
            var ret = openstc.task.preValidate(data);
            if (data.action.id === 'add' && data.model._task_id) {
                data.action.http.url = '/web/dataset/save';
            }
            return ret;
        };

        $scope.callbackTask = openstc.task.callback;

        $scope.setCurrentItem = function (item) {
            $scope.tasks.setCurrent(item)
            .then(function () {
                $scope.tasks.updateLocation();
            });
        };
    }

    function TaskRecurrentDeleteController ($scope, swif) {
        $scope.tasks = [$scope.model];

        $scope.$watch('model.recurrence.recurrenceChoice', function (newV, oldV){
            if (newV != oldV) {
                if (newV==='fromThisTask'){
                    let tfilter = {};
                    swif.data.addFilter(tfilter, 'recurrence_id', '=', $scope.model.recurrence_id[0]);
                    swif.data.addFilter(tfilter, 'date_start', '>=', $scope.model.date_start.toString());
                    swif.data.searchRead('task', tfilter)
                        .then(function (data) {
                            $scope.tasks = data.records;
                            $scope.model.ids = _.pluck(data.records, 'id');
                        });
                }
                if (newV==='whole'){
                    let tfilter = {};
                    swif.data.addFilter(tfilter, 'recurrence_id', '=', $scope.model.recurrence_id[0]);
                    swif.data.searchRead('task', tfilter)
                        .then(function (data) {
                            $scope.tasks = data.records;
                            $scope.model.ids = _.pluck(data.records, 'id');
                        });
                }
                if (newV==='onlyThisTask'){
                    let tfilter = {};
                    swif.data.addFilter(tfilter, 'recurrence_id', '=', $scope.model.recurrence_id[0]);
                    swif.data.addFilter(tfilter, 'date_start', '=', $scope.model.date_start.toString());
                    swif.data.searchRead('task', tfilter)
                        .then(function (data) {
                            $scope.tasks = data.records;
                            $scope.model.ids = _.pluck(data.records, 'id');
                        });
                }
            }
        });
    }

})();
